'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosEye = function IoIosEye(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.9 20l0.1 0.1-0.5 0.4c-1.6 1.7-3.6 3.8-6.1 5.4-2.8 1.9-5.6 2.9-8.4 2.9-6.5 0-10.2-3.9-14.5-8.3l-0.5-0.5 0.1-0.1c3-3.1 5.2-5 7.3-6.3 2.5-1.6 4.9-2.3 7.6-2.3 6.5 0 11.4 4.6 14.9 8.7z m-14.9 6.3c3.4 0 6.3-2.9 6.3-6.3s-2.9-6.2-6.3-6.2-6.2 2.8-6.2 6.2 2.8 6.3 6.2 6.3z m-0.5-8.6c0 1.5 1.3 2.8 2.8 2.8 0.5 0 1.1-0.2 1.4-0.5 0 2.1-1.7 3.7-3.7 3.7s-3.8-1.6-3.8-3.7 1.8-3.8 3.8-3.8c-0.3 0.4-0.5 1-0.5 1.5z' })
        )
    );
};

exports.default = IoIosEye;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-eye.js
// module id = 2178
// module chunks = 0